import { Icon } from '@iconify/react'
import { useEffect, useState } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

import { Modal, Spin, usePaginatedProjects } from '@pepper/ui'

import { useSelectedCompanyId } from 'utils/functions/misc'

import ProjectPicker from './ProjectPicker'
import CreateProjectForm from './CreateProjectForm'

import s from './SelectProjectModal.module.css'

type Props = {
  onAfterSelectId: (
    id: string,
    isDomainConnected: boolean
  ) => void | Promise<void>
  activeDomainId?: string
  onClose?: () => void
}

export const SelectProjectModal = NiceModal.create(
  ({ onAfterSelectId, onClose, activeDomainId }: Props) => {
    const [isLoading, setIsLoading] = useState(false)
    const companyId = useSelectedCompanyId()
    const { totalProjects, isProjectsLoading } = usePaginatedProjects({
      company_id: companyId,
      page_size: 1,
    })

    const [mode, setMode] = useState<'SELECT' | 'CREATE'>('CREATE')
    const { visible, remove } = useModal()

    // Not sending `isDomainConnected` for new Projects and considering
    // domain connected by default
    const handleOnAfterSelectId = async (
      _projectId: string,
      isDomainConnected = true
    ) => {
      setIsLoading(true)
      await onAfterSelectId(_projectId, isDomainConnected)
      setIsLoading(false)
      onClose?.()
      remove()
    }
    useEffect(() => {
      if (totalProjects > 0) {
        setMode('SELECT')
      }
    }, [totalProjects, isProjectsLoading])
    return (
      <Modal
        title={mode === 'SELECT' ? 'Select Project' : 'Create New Project'}
        size="lg"
        visible={visible}
        onCancel={remove}
        footer={null}
        destroyOnClose={true}
        {...(mode === 'CREATE' && { size: 'md' })}
      >
        <Spin spinning={isLoading}>
          {mode === 'SELECT' && (
            <ProjectPicker
              onProjectClick={handleOnAfterSelectId}
              onCreateNew={() => setMode('CREATE')}
              activeDomainId={activeDomainId}
            />
          )}

          {mode === 'CREATE' && (
            <CreateProjectForm
              onClose={remove}
              onCreate={handleOnAfterSelectId}
              domainId={activeDomainId}
              footerAction={
                <button
                  className={s.backBtn}
                  type="button"
                  onClick={() => {
                    setMode('SELECT')
                  }}
                  disabled={totalProjects <= 0}
                >
                  <Icon icon="lucide:chevron-left" width={16} height={16} />
                  Select Project
                </button>
              }
            />
          )}
        </Spin>
      </Modal>
    )
  }
)
